//@ts-ignore
import queryString from 'query-string';
export const getStoreIdFromURL = (): string | undefined => {
  const url = window.location.search;
  const { q: storeId } = queryString.parse(url);
  return storeId;
};
